<div class="outer-container">
    <div class="progress-tracker"
         [ngClass]="{ 'progress-tracker--details': detailsPage }">
        <!-- Analysis -->
        <div class="progress-tracker__step"
             [ngClass]="{
               'progress-tracker__step--green': analysis && !cancelled,
               'progress-tracker__step--grey': !analysis
            }">
            <div class="progress-tracker__label">Analysis</div>
            <div class="progress-tracker__circle"
                 [ngClass]="{
                   'progress-tracker__circle--complete': analysis && offered,
                   'progress-tracker__circle--cancelled': analysis && cancelled,
                   'progress-tracker__circle--details': detailsPage
                }"></div>
        </div>

        <!-- Offered -->
        <div class="progress-tracker__step"
             [ngClass]="{
               'progress-tracker__step--green': offered && !cancelled,
               'progress-tracker__step--grey': !offered
            }">
            <div class="progress-tracker__label">Offered</div>
            <div class="progress-tracker__circle"
                 [ngClass]="{
                   'progress-tracker__circle--complete': offered && active,
                   'progress-tracker__circle--cancelled': offered && cancelled,
                   'progress-tracker__circle--details': detailsPage
                }"></div>
        </div>

        <!-- Active -->
        <div class="progress-tracker__step"
             [ngClass]="{
               'progress-tracker__step--green': active && !cancelled && !acceptedUnpublished,
               'progress-tracker__step--grey': !active && !acceptedUnpublished,
               'progress-tracker__step--yellow': !active && acceptedUnpublished
            }">
            <div class="progress-tracker__label">Active</div>
            <div class="progress-tracker__circle"
                 [ngClass]="{
                   'progress-tracker__circle--complete': active && pending,
                   'progress-tracker__circle--cancelled': active && cancelled,
                   'progress-tracker__circle--details': detailsPage
                }"></div>
        </div>

        <!-- Pending -->
        <div class="progress-tracker__step"
             [ngClass]="{
               'progress-tracker__step--green': pending && !cancelled,
               'progress-tracker__step--grey': !pending
            }">
            <div class="progress-tracker__label">Pending</div>
            <div class="progress-tracker__circle"
                 [ngClass]="{
                   'progress-tracker__circle--complete': pending && (closed || cancelled),
                   'progress-tracker__circle--cancelled': pending && cancelled,
                   'progress-tracker__circle--details': detailsPage
                }"></div>
        </div>

        <!-- Closed -->
        <div class="progress-tracker__step"
             *ngIf="!cancelled"
             [ngClass]="{
               'progress-tracker__step--green': closed,
               'progress-tracker__step--grey': !closed
            }">
            <div class="progress-tracker__label">Closed</div>
            <div class="progress-tracker__circle"></div>
        </div>

        <!-- Cancelled -->
        <div class="progress-tracker__step"
             *ngIf="cancelled"
             [ngClass]="{ 'progress-tracker__step--red': cancelled }">
            <div class="progress-tracker__label progress-tracker__label--cancelled">Cancelled</div>
            <div class="progress-tracker__circle"></div>
        </div>
    </div>
</div>
